import * as kitTypesService from '../../../services/KitTypes/kitTypesService.js';
import * as daHelper from '../dialogActionsHelper';
import {dialogsNames} from '../../../enums/dialogsNames';


const config = {
  getSubmitMethod: (submitConfigData) => {
    return submitConfigData?.isMultiKitTypes ?
      kitTypesService.updateWorkOrdersMultiKitTypesVersions : kitTypesService.updateWorkOrdersKitTypeVersion
  },
};

export const actionTypes = {
  ...daHelper.getActionTypes(dialogsNames.UPDATE_KIT_TYPE_VERSION_DIALOG),
};

const actions = {
  ...daHelper.getActions(dialogsNames.UPDATE_KIT_TYPE_VERSION_DIALOG),

};

export let api = {
  ...daHelper.getApiActions(actions, config),
}

export let jsxActions = {
  ...daHelper.getJsxActions(api),

};
